import type { MittwaldAPIV2 } from "@mittwald/api-client-NEXT";
import type { Project } from "../../project/index.js";

export type AppInstallationData =
  MittwaldAPIV2.Operations.AppGetAppinstallation.ResponseData;

export type AppInstallationListItemData =
  MittwaldAPIV2.Operations.AppListAppinstallations.ResponseData[number];

export type AppInstallationListQueryData =
  MittwaldAPIV2.Paths.V2ProjectsProjectIdAppInstallations.Get.Parameters.Query;

export type AppInstallationListQueryModelData = AppInstallationListQueryData & {
  project?: Project;
};

export type AppInstallationCreateRequestData =
  MittwaldAPIV2.Paths.V2ProjectsProjectIdAppInstallations.Post.Parameters.RequestBody;

export type AppInstallationUpdateRequestData =
  MittwaldAPIV2.Paths.V2AppInstallationsAppInstallationId.Patch.Parameters.RequestBody;

export type AppInstallationLinkDatabaseRequestData =
  MittwaldAPIV2.Paths.V2AppInstallationsAppInstallationIdDatabase.Patch.Parameters.RequestBody;

export type AppInstallationStatus =
  MittwaldAPIV2.Operations.AppRetrieveStatus.ResponseData;

export type AppInstallationCopyRequestData =
  MittwaldAPIV2.Paths.V2AppInstallationsAppInstallationIdActionsCopy.Post.Parameters.RequestBody;

export type AppSavedUserInput =
  MittwaldAPIV2.Components.Schemas.AppSavedUserInput;

export type ReplacePrimaryDatabaseRequestData =
  MittwaldAPIV2.Paths.V2AppInstallationsAppInstallationIdDatabaseReplace.Patch.Parameters.RequestBody;

export type InstalledSystemSoftwareQuery =
  MittwaldAPIV2.Paths.V2AppInstallationsAppInstallationIdSystemSoftware.Get.Parameters.Query;

export enum AppIds {
  nodejs = "3e7f920b-a711-4d2f-9871-661e1b41a2f0",
  python = "be57d166-dae9-4480-bae2-da3f3c6f0a2e",
  staticFiles = "d20baefd-81d2-42aa-bfba-9a3220ae839b",
}
